// Navigation-experience Sentry DSN
export const SENTRY_DSN =
	'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';

export const SENTRY_TEAM_NAME = 'afe-navigation-experience';

/**
 * Patterns for known backend / network errors that we don't want to log to Sentry.
 * These are bubbled up from product BFF / network layers and are not actionable in the FE.
 *
 * Consumed by `isSuppressedBackendError` (in `./index.ts`) inside `beforeSend`, and
 * also spread into the live `BrowserClient`'s `ignoreErrors` at setup time. Both
 * usages are gated behind feature flag `navx-4946-sentry-filtering` (see `./index.ts`).
 *
 * IMPORTANT: These patterns are tested against the exception's `value` field
 * (the raw error message) only — not against an assembled `"${type}: ${value}"`
 * string — so that the same patterns work regardless of how Sentry stringifies
 * the exception type. Keep them unanchored on the left so they also match the
 * Sentry runtime `ignoreErrors` filter (which compares against the full assembled
 * message including the type prefix, e.g. `"Error: Failed to fetch data: 500"`).
 */
export const SUPPRESSED_BACKEND_ERROR_PATTERNS: RegExp[] = [
	/Failed to fetch$/i, // Chromium network failure (raw value: "Failed to fetch")
	/NetworkError when attempting to fetch/i, // Firefox
	/Load failed$/i, // Safari network failure
	/Failed to fetch data:\s*5\d{2}/i, // BFF 5xx surfaced from fetchJSON
	/AbortError/i, // request aborted
	/The user aborted a request/i,
];

export const DEFAULT_SENTRY_CONFIG: {
	attachStacktrace: boolean;
	ignoreErrors: RegExp[];
	ignoreUrls: RegExp[];
	whitelistUrls: RegExp[];
} = {
	whitelistUrls: [/atl-paas.net/, /localhost/],
	ignoreErrors: [/^SentryIgnore:/],
	ignoreUrls: [/extensions\//i, /^chrome:\/\//i],
	attachStacktrace: true,
};

export const SENTRY_PRODUCT = 'navigation';
